'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _uiTranslations = require('@wh/ui-translations');

var _actions = require('../login-component/actions');

var _message = require('./message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = {
    accountRecoveryClicked: _actions.accountRecoveryClicked
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _uiTranslations.withTranslator)(_message2.default));
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/message/Container.js
// module id = 496
// module chunks = 0